export const getCookie = name => {
  if (typeof window === 'undefined') return undefined;
  if (typeof document === 'undefined') return undefined;
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};

export default getCookie;
